// extracted by mini-css-extract-plugin
export default {"question_box":"Questions_question_box__oGVOd","btn":"Questions_btn__LXTXd"};